import React, { Component } from 'react';
import Loader from '../../components/loader/loader';
import { Link } from 'react-router-dom';
import './newUser.scss';
import { request } from '../../constants/constants';
import UserContext from '../../contexts/user';
import ReactTable from 'react-table';
import Pagination from '../../components/pagination/pagination';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

class NewUser extends Component {

    static contextType = UserContext;

    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            administrator: false,
            upload: false,
            modal: false,
			selected: {},
			pageSize: 10,
			currentPage: 1,
			selectedAll: {},
			indeterminateSign: false,
            isLoading: false,
            teams: [],
            gender: [
				'Men',
				'Women',
				'Boys',
				'Girls',
				'Mixed'
			],
			search: ''
        }
    }

    handleTextChange = e => {
        console.log(e.target.name);
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    handleCheckbox = e => {
        this.setState({
            [e.target.name]: e.target.checked
        })
    }
    handleSubmit = e => {
        e.preventDefault();
        this.setState({
            isLoading: true
        })
        const teamIds = [];
        Object.keys(this.state.selected).forEach(key => {
            if(this.state.selected[key]) teamIds.push(key); 
        });
        const data = {
            name: this.state.name,
            email: this.state.email,
            administrator: this.state.administrator,
            upload: this.state.upload,
            teams: teamIds
        }
        request('POST',`/auth/organisation/${this.context.user.current_org}/users`, data, true)
        .then(res => {
            console.log(res);
            this.setState({
                isLoading: false
            })
            Swal.fire(
                'Success',
                'User Invitation sent.',
                'success'
            )
        }).catch(err => {
            this.setState({
                isLoading: false
            })
            console.error(err.response);
            Swal.fire(
                'Error',
                err.response.data.message,
                'error'
            )
        })
    }
    showModal = () => {
		this.setState({
			modal: true
		})
	}
	closeModal = () => {
		this.setState({
			modal: false
		})
	}

	toggleSelectAll() {
		let newSelected = {};
		let newSelectPage;
		const start = (this.state.currentPage - 1) * this.state.pageSize;
		const end = start + this.state.pageSize;
		if (this.state.selectedAll[this.state.currentPage] === false || this.state.selectedAll[this.state.currentPage] == null || this.state.indeterminateSign === true) {
			newSelectPage = Object.assign(this.state.selectedAll, { [this.state.currentPage]: true});
			this.state.teams.slice(start, end).forEach(data => {
				newSelected[data.id] = true;
			});
			let newObj = Object.assign(this.state.selected, newSelected);
		
			this.setState({
				selected: newObj,
				selectedAll: newSelectPage,
				indeterminateSign: false,
			});
		} else {
			newSelectPage = Object.assign(this.state.selectedAll, { [this.state.currentPage] : false });
			this.state.teams.slice(start, end).forEach(data => {
				newSelected[data.id] = false;
			});
			let newObj = Object.assign(this.state.selected, newSelected);
			// const selectedGames = Object.keys(newObj).filter(obj => {
			// 	return newObj[obj] === true;
			// });

			// this.props.selectedGames(selectedGames);
			this.setState({
				selected: newObj,
				selectedAll: newSelectPage,
				currentSelectedTeams: []
			});
		}
	}
	toggleRow(team) {
		const teamId = team.id;
		const newSelected = Object.assign({}, this.state.selected);
		newSelected[teamId] = !this.state.selected[teamId];
		this.setState({
			selected: newSelected
		});
	}

	handleThProps(state, rowInfo, column, instance) {
		return {
			onClick: (e) => {
				if (column.sortable !== false) {
					if (column.className !== 'header-checkbox-toggle') {
						instance.sortColumn(column)
					}
				}
			}
		}
	}

	handlePageChange(data) {
		this.setState({ currentPage: data + 1 });
	}

	handlePageSizeChange(data) {
		if (this.state.pageSize < data) {
			this.setState({ pageSize: data }, () => {
				if (this.state.selectedAll[this.state.currentPage] === true) {
					this.setState({
						indeterminateSign: true
					})
				}
			});
		} else {
			this.setState({ pageSize: data }, () => {
				const start = (this.state.currentPage - 1) * this.state.pageSize;
				const end = start + this.state.pageSize;
				let newSelected = {};
				let newSelectPage;
				if (this.state.selectedAll[this.state.currentPage] === true) {
					newSelectPage = Object.assign(this.state.selectedAll, { [this.state.currentPage]: true });
					this.state.teams.forEach(data => {
						newSelected[data.id] = false;
					});
					this.state.teams.slice(start, end).forEach(data => {
						newSelected[data.id] = true;
					});
					let newObj = Object.assign(this.state.selected, newSelected);
					const selectedList = Object.keys(newObj).filter(obj => {
						return newObj[obj] === true;
					});
					// this.props.selectedList(selectedList);
					this.setState({
						selected: newObj,
						selectedAll: newSelectPage,
						indeterminateSign: false
					});
				}
			});
        }
	}
	
	getAllTeams() {
		return request(
			'GET',
			`/auth/organisation/${this.context.user.current_org}/teams`,
			{},
			true
		)
    }
    
    componentDidMount() {
        this.setState({
            isLoading: true
        })
        this.getAllTeams().then(res => {
            console.log(res)
            this.setState({
                isLoading: false,
                teams: res.data.data
            })
        }).catch(err => {
            console.error(err);
            this.setState({
                isLoading: false
            })
        })

    }

    render() {
        let data = this.state.teams;
        if (this.state.search) {
			data = data.filter(row => {
				return row.team_name.toLowerCase().includes(this.state.search.toLowerCase());
			})
		}
		const columns = [
			{
				Header: (header) => (
					<div className="custom-control custom-checkbox" style={{ marginLeft: 15 }}>
						<input
							type="checkbox"
							className="custom-control-input"
							id="selectAllCheckBox"
							checked={this.state.selectedAll[this.state.currentPage] || false}
							onChange={() => this.toggleSelectAll()}
							ref={input => {
								if (input) {
									input.indeterminate = this.state.indeterminateSign;
								}
							}}
						/>
						<label className="custom-control-label" htmlFor="selectAllCheckBox"></label>
					</div>
				),
				width: 52,
				Cell: row => (
					<div className="custom-control custom-checkbox" style={{ marginLeft: 15 }}>
						<input type="checkbox" className="custom-control-input" id={`game-id-${row.original.id}`} checked={this.state.selected[row.original.id] || false} onChange={() => this.toggleRow(row.original)} />
						<label className="custom-control-label" htmlFor={`game-id-${row.original.id}`}></label>
					</div>
				),
				className: 'header-checkbox-toggle',
				headerStyle: { padding: '1.07143em 0' },
				style: { padding: '0.71429em 0' }
				
			},
			{
				Header: 'Name',
				minWidth: 250,
				accessor: 'team_name'
			},
			{
				Header: 'League',
				Cell: row => (
					<span>{row.original.league && row.original.league.league_name}</span>
				),
			},
			{
				Header: 'Gender',
				Cell: row => (
					<span>{row.original.gender && this.state.gender[row.original.gender]}</span>
				),
			},
		]
        return (
            <div className="official-add">
                <div className="page-head mb_30">
                    <div className="head">
                        <h1 className="page-title">Invite User</h1>
                        <nav>
                            <ol className="breadcrumb page-title">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item"><Link to="/users">Users</Link></li>
                                <li className="breadcrumb-item current">Invite User</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <div className="box">
                    <div className="card card-border card-invite-official mb_30">
                        <div className="card-header d-flex align-items-center justify-content-between">
                            <h2>Invite User</h2>
                        </div>
                        <form onSubmit={this.handleSubmit} id="official-invite-form">
                            <div>{this.props.form_success}</div>
                            {this.props.isLoading && <Loader />}
                            <div className="card-body">
                                <div className="permission">
                                    <div className="row">
                                        <div className="col-xl-3 col-lg-6 col-md-12 col-12">
                                            <div className="form-group">
                                                <label className="label">Name</label>
                                                <div className="input-effect-1">
                                                    <input name="name" type="text" value={this.state.name} onChange={this.handleTextChange} className="form-control" placeholder="Your Name" />
                                                    <span className="focus-border"></span>
                                                </div>
                                                {/* {name_error} */}
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-lg-6 col-md-12 col-12">
                                            <div className="form-group">
                                                <label className="label">Email</label>
                                                <div className="input-effect-1">
                                                    <input name="email" type="text" value={this.state.email} onChange={this.handleTextChange} className="form-control" placeholder="Your Email" />
                                                    <span className="focus-border"></span>
                                                </div>
                                                {/* {email_error} */}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col">
                                            <h3 className="subtitle">Permission</h3>
                                            <div className="form-group">
                                                <div className="custom-checkbox custom-control-inline">
                                                    <input name="administrator" type="checkbox" checked={this.state.administrator} onChange={this.handleCheckbox} id="administrator" className="custom-control-input" />
                                                    <label htmlFor="administrator" className="custom-control-label">
                                                        Administrator
                                                    </label>
                                                </div>
                                                <div className="custom-checkbox custom-control-inline">
                                                    <input name="upload" type="checkbox" checked={this.state.upload} onChange={this.handleCheckbox} id="allocator" className="custom-control-input" />
                                                    <label htmlFor="allocator" className="custom-control-label">
                                                        Upload
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {
                                        this.state.upload && (
                                            <div className="row">
                                            <div className="col">
                                                    <label className="label">Team(s)</label>
                                                    <div className="table-area">
                                                    <div className="heading mb_20">
                                                        <div className="dflex justify-content-end">
                                                            <div className="search-table">
                                                                <div className="input-group">
                                                                    <input type="text" value={this.state.search} onChange={e => this.setState({ search: e.target.value })} className="form-control" placeholder="Search" />
                                                                    <div className="input-group-append">
                                                                        <button className="input-group-text"><FontAwesomeIcon icon={faSearch} className="fa fa-search" /></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                        {(this.state.isLoading) && <Loader />}
                                                            <ReactTable
                                                                PaginationComponent={Pagination}
                                                                data={data}
                                                                minRows={5}
                                                                columns={columns}
                                                                noDataText={this.state.isLoading ? '' : "No Teams Found."}
                                                                defaultPageSize={this.state.pageSize}
                                                                pageSizeOptions={[10, 25, 50, 100]}
                                                                // resizable={true}
                                                                onPageChange={(index) => this.handlePageChange(index)}
                                                                onPageSizeChange={(size) => this.handlePageSizeChange(size)}
                                                                getTheadThProps={(state, rowInfo, column, instance) => this.handleThProps(state, rowInfo, column, instance)}
                                                            />
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                             
                                    <div className="action">
                                        <button type="submit" className="btn btn-orange" name="submit" >
                                        {
                                            this.state.isLoading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : 'Send'
                                        }
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default NewUser;